
import FavoriteButton from "./Components/FavoriteButton";
import AlarmButton from "./Components/AlarmButton";
import ShareButton from "./Components/ShareButton";


const Options = () => {
  
  return (
    <>
    
     
       <FavoriteButton/>
        <AlarmButton/>
        <ShareButton  />
      
    </>
  );
};

export default Options;
